<template>
  <div class="overall-bg p-0">
    <b-container>
      <b-row class="tabviewtable">
        <b-col>
          <!-- {{ items }} -->
          <div class="form-white-bg" v-if="windowWidth > 545">
            <b-row>
              <b-col :lg="items.length !== 0 && visible ? '9' : '12'">
                <SkeletonTableLoader :columns="headers" :loading="loading" />
                <div v-if="!loading">
                  <MasterEmpty v-if="
                    items.length === 0 &&
                    !SearchValue.inputValue &&
                    !SearchValue.fromDate &&
                    !hasData &&
                    !SearchValue.toDate
                  " eheader="IndentTemplate" econtent="IndentTemplate" eimg="/src/assets/Img/icons/sub-tax.svg"
                    @createNew="IsCreate" />
                  <Tableview v-if="
                    items.length !== 0 ||
                    SearchValue.inputValue ||
                    SearchValue.fromDate ||
                    hasData ||
                    SearchValue.toDate
                  " :value="items" :paginator="false" class="p-datatable-gridlines commonstatusclass" :rows="10"
                    dataKey="id" :rowHover="true" filterDisplay="menu" :loading="loading1" responsiveLayout="scroll"
                    :columns="headers" :globalFilterFields="globalFilterFields" :filters="filters" @row-click="RowClick"
                    :totalRecords="rowsCount" :state="state" @ShowRows="ShowRows" :searchbox="true" :searchbox1="false"
                    :exceldownload="true" :filterbtn="false" :statusFilterBtn="false">
                    <template v-slot:filter>
                      <i class="pi pi-filter tablefilter" :class="visible ? null : 'collapsed'"
                        :aria-expanded="visible ? 'true' : 'false'" aria-controls="collapse-4"
                        @click="visible = !visible"></i>
                    </template>
                    <template v-slot:Add>
                      <span class="add">
                        <AddButton @click="IsCreate()" :btnname="$t('btn.plusaddnew')"></AddButton>
                      </span>
                    </template>
                    <template v-slot:status="{ data }">
                      <OrangeStatus name="Pending" v-if="data.Status == '0'" />
                      <OrangeStatus name="Converted To PI" v-if="data.Status == '1'" />
                      <GreenStatus name="Issued" v-if="data.Status == '2'" />
                      <BlueStatus name="Partially Issued" v-if="data.Status == '3'" />
                      <BlueStatus name="Converted to PR" v-if="data.Status == '4'" />
                      <BlueStatus name="Partially Converted to PR" v-if="data.Status == '5'" />
                      <RedStatus name="Closed" v-if="data.Status == '6'" />
                    </template>
                    <template v-slot:action="{ data }">
                      <span>
                        <Button icon="pi pi-ellipsis-v" class="p-button-rounded editicon p-button-text"
                          @click="toggle($event, data)" />
                      </span>
                    </template>
                  </Tableview>
                </div>
              </b-col>
            </b-row>
          </div>
          <div v-if="windowWidth <= 545">
            <MobileLoader v-if="loading" v-for="items in 5" />
            <div v-if="!loading">
              <MasterEmpty v-if="items.length === 0" eheader="Indent Template" econtent="Indent Template"
                eimg="/src/assets/Img/icons/sub-tax.svg" @createNew="IsCreate" />
              <MobileViewCardHeader v-else :totalRecords="rowsCount" :state="state">
                <template v-slot:mobilecard>
                  <div class="mobile-card" v-for="item in items" @click="">
                    <div class="d-flex align-items-center justify-content-between gap-2">
                      <div>
                        <p class="light-name">{{ item["DocNo"] }}</p>
                        <p class="name">{{ item["FromStoreName"] }}</p>
                      </div>
                      <div class="d-flex align-items-center">
                        <div>
                          <OrangeStatus name="Pending" v-if="item['Status'] == '0'" />
                          <OrangeStatus name="Converted To PI" v-if="item['Status'] == '1'" />
                          <GreenStatus name="Issued" v-if="item['Status'] == '2'" />
                          <BlueStatus name="Partially Issued" v-if="item['Status'] == '3'" />
                          <BlueStatus name="Converted to PR" v-if="item['Status'] == '4'" />
                          <BlueStatus name="Partially Converted to PR" v-if="item['Status'] == '5'" />
                          <RedStatus name="Closed" v-if="item['Status'] == '6'" />
                        </div>

                        <i class="pi pi-ellipsis-v" @click.stop="toggle($event, item)"></i>
                      </div>
                    </div>
                  </div>
                </template>
              </MobileViewCardHeader>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>

  <Menu ref="menus" id="overlay_menu" :model="itemListed" @click="" :popup="true" />
  <EditConfirmation :Editmodel="popup.Editmodel" @yes="IsEdit(dataEdit)" @no="popup.Editmodel = false"
    :content="$t('confirmation.editcontent')" />
  <DeleteConfirmationVue :DeleteModel="popup.Deletemodel" @yes="IsDelete(dataEdit)" @no="popup.Deletemodel = false" />
  <DeletedSuccessfully :visible="popup.deletepop" @ok="closetrigger()" />
  <CrystalReportPrintPopUp :ShowAndHide="CrystalReportPopup" :ParameterValues="ParameterValues" :PrintType="PrintType"
    @closepopup="hidepopup" />
  <Toast />
</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  h,
  onMounted,
  watch,
  reactive,
  onUnmounted,
} from "vue";
import Headerlayout from "../../../../../../../components/Masters/HeaderLayout.vue";
import BacktoPage from "../../../../../../../components/FormComponents/BacktoMaster.vue";

import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";

import Table from "../../../../../../../components/FormComponents/Table.vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import Tableview from "../../../../../../../components/FormComponents/Table.vue";
import { useI18n } from "vue-i18n";
import commonService from "../../../../../Service/IndentTemplateService";
import DeleteConfirmationVue from "../../../../../../../components/FormComponents/DeleteConfirmation.vue";
import poGrnFilters from "../../../../../../../modules/Inventory/components/Filters/poGrnFilters.vue";

import DeletedSuccessfully from "../../../../../../../components/FormComponents/DeletedSuccessfully.vue";
import EditConfirmation from "../../../../../../../components/FormComponents/EditConfirmation.vue";
import Loader from "../../../../../../../components/FormComponents/Loader.vue";
import MasterEmpty from "../../../../../../../components/Masters/MasterEmpty.vue";
import { useToast } from "primevue/usetoast";
import { checkPermission } from "../../../../../../../modules/Inventory/Service/AccessControl";
import SkeletonTableLoader from "../../../../../../../components/FormComponents/SkeletonTableLoader.vue";
import MobileViewCardHeader from "../../../../../../../components/FormComponents/MobileViewCardHeader.vue";
import MobileLoader from "../../../../../../../components/SkeletonLoaderComponents/ContactCardView.vue";
import CrystalReportPrintPopUp from "../../../../../../../modules/Inventory/components/Print/CrystalReportPrint.vue";
import FilterForm from "../../../../../../../components/FormComponents/FilterForm.vue";
import moment from "moment";
import requestFilters from "../../../../../../../modules/Inventory/components/Filters/requestFilters.vue";
import ExportOption from "../../../../../../../components/FormComponents/Export.vue";

export default defineComponent({
  components: {
    BacktoPage,
    Headerlayout,

    Table,
    Tableview,
    DeleteConfirmationVue,
    DeletedSuccessfully,
    EditConfirmation,
    Loader,
    MasterEmpty,
    SkeletonTableLoader,
    MobileViewCardHeader,
    MobileLoader,
    CrystalReportPrintPopUp,
    FilterForm,
    requestFilters,
    poGrnFilters,
    ExportOption,
  },
  props: {
    propsParams: {
      type: Object,
    },
    FunctionRights: {
      type: Object,
    },
  },
  setup(props) {
    onMounted(() => {
      IsShow();
    });
    const { t } = useI18n();
    const routes = useRoute();
    const hasData = ref(false);
    const rowFocus = ref(false);
    let StoreId = routes.query.Id ?? 0;
    let status = routes.query.status ?? 0;
    let Type = routes.query.Type;
    let StoreBranchmapId = routes.query.storebranchmapid;
    const datas = ref();
    const menus = ref();
    const Activevisible = ref(false);
    const CrystalReportPopup = ref(false);
    const menu = ref();
    const dataEdit = ref();
    let Id = ref();
    const router = useRouter();
    const generic = ref();
    let items = ref([]);
    let loading1 = ref(false);
    let loading = ref(false);
    let visible = ref(false);
    const IsPending = ref(false);
    const ParameterValues = ref({
      Id: 0,
      BranchId: 0,
      HospitalId: 0,
    });

    let dataValue = {
      Id: "",
      status: "",
    };

    let ObjOperationId = ref({
      CreateId: 0,
      UpdateId: 0,
      ReadId: 0,
      DeleteId: 0,
      EntityId: 0,
    });

    let StatusFilter = ref({
      StatusFrom: "InBReq",
      Status: true,
    });

    watch(props, (newValue) => {
      debugger;
      Object.assign(dataValue, newValue.propsParams);
      if (dataValue.Id) {
        items.value = [];
        StoreId = dataValue.Id;
        status = dataValue.status;
        IsShow();
      }
    });

    const PrintType = ref({
      Type: "T",
      FormId: 103,
      HeaderTitle: "Indent template",
      ModuleId: 3,
    });

    const popup = ref({
      Deletemodel: false,
      deletepop: false,
      Editmodel: false,
    });

    const toast = useToast();
    let Rights: any = ref({
      Create: false,
      Update: false,
      Read: false,
      Delete: false,
    });

    watch(
      props,
      (newValue: any) => {
        debugger;
        console.log("props Changed", newValue.FunctionRights);
        Rights.value.Create = newValue.FunctionRights.Create;
        Rights.value.Update = newValue.FunctionRights.Update;
        Rights.value.Read = newValue.FunctionRights.Read;
        Rights.value.Delete = newValue.FunctionRights.Delete;
        Object.keys(ObjOperationId.value).forEach((key) => {
          if (newValue.FunctionRights[key])
            ObjOperationId.value[key] = newValue.FunctionRights[key];
        });
      },
      { deep: true }
    );

    function toggle(event, data) {
      debugger;
      console.log(event);
      if (data.Status == "0") {
        Activevisible.value = true;
      } else {
        Activevisible.value = false;
      }

      IsPending.value =
        data.Status == "0" && data.IsApproved == 1 ? true : false;
      datas.value = data;

      menus.value.toggle(event);
    }
    const hidepopup = () => {
      CrystalReportPopup.value = false;
    };

    const itemListed = ref([
      {
        items: [
          {
            label: "Edit",
            icon: "editicon pi pi-pencil",
            visible: Activevisible,
            command: async () => {
              IsConfirmEdit(datas.value);
            },
          },
          {
            label: "Delete",
            icon: "deleteicon pi pi-trash",
            visible: Activevisible,
            command: async () => {
              IsConfirmDel(datas.value);
            },
          },
          {
            label: "Print",
            icon: "editicon pi pi-print",
            command: async () => {
              Print(datas.value);
            },
          },
          // {
          //   label: "Close",
          //   icon: "deleteicon pi pi-times",
          //   visible: IsPending,
          // },
        ],
      },
    ]);

    const ParamValues = ref({
      requestId: "",
      StockWOTransTMId: 0,
      fromStoreId: 0,
      toStoreId: 0,
      type: 1,
      StoreId: StoreId,
      status: status,
      Types: Type,
    });

    function IssueOncick(data) {
      debugger;
      console.log(data["DocNo"]);
      ParamValues.value.requestId = data["DocNo"];
      ParamValues.value.StockWOTransTMId = data["StockTransId"];
      ParamValues.value.fromStoreId = data["FromStoreId"];
      ParamValues.value.toStoreId = data["ToStoreId"];
      router.push({
        path: "/Issue",
        query: {
          data: JSON.stringify(ParamValues.value),
          param: "IndirectIssue",
        },
      });
    }
    function Print(ObjData) {
      debugger;
      CrystalReportPopup.value = true;

      ParameterValues.value.Id = ObjData.StockTransId;
      ParameterValues.value.BranchId = ObjData.BranchId;
      ParameterValues.value.HospitalId = ObjData.HospitalId;
    }

    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      DocNo: { value: null, matchMode: FilterMatchMode.IN, options: items },
      DocDate: { value: null, matchMode: FilterMatchMode.IN, options: items },
      FromStoreName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
      ToStoreName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
      RequestStatusName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
      RooName: { value: null, matchMode: FilterMatchMode.IN, options: items },
    };

    const headers = [
      {
        header: t("storetabdetails.indenttemplate.sno"),
        field: "RowNumber",
        class: "filterdisplaynone smallwidth",
      },
      // {
      //   field: "RequestStatusName",
      //   fieldDisplay: "false",
      //   header: "Status",
      //   slot: "status",
      //   sortable: false,
      //   filterTemplate: "MultiSelect",
      //   ShowMactchMode: false,
      //   class: "smallwidth",
      // },
      {
        header: t("storetabdetails.indenttemplate.Code"),
        field: "DocNo",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.indenttemplate.Name"),
        field: "TemplateName",
        bodyclass: "boldclass",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.indenttemplate.Date"),
        field: "DocDateHR",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      // {
      //   header: "From Store",
      //   field: "FromStoreName",
      //   filterTemplate: "MultiSelect",
      //   ShowMactchMode: false,
      // },
      // {
      //   header: "To Store",
      //   field: "ToStoreName",
      //   filterTemplate: "MultiSelect",
      //   ShowMactchMode: false,
      //   bodyclass: "boldclass text_overflow2",
      //   class: "mediumwidth",
      // },

      {
        header: t("storetabdetails.indenttemplate.ItemCount"),
        field: "ItemCount",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.indenttemplate.Qty"),
        field: "ItemQty",
        bodyclass: "right_td",

        class: "smallwidth",
      },

      {
        field: "action",
        header: "",
        slot: "action",
        frozencolumn: true,
        sortable: false,
        class: "filterdisplaynone last-column-position",
        fieldDisplay: "false",
      },
    ];

    const globalFilterFields = ref(headers.map((col) => col.field));

    //get local storage session data
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData: any;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }
    const IsCreate = () => {
      debugger;
      let permissionResult: any = checkPermission(Rights, "Add");

      if (permissionResult.hasPermission) {
        router.push({
          name: "IndentTemplateCreation",
          query: {
            doctype: "21",
            param: "IndentTemplateCreation",
            StoreId: StoreId,
            status: status,
            Type: Type,
            OperationId: ObjOperationId.value.CreateId,
            EntityId: ObjOperationId.value.EntityId,
            storebranchmapid: StoreBranchmapId,
            BranchId: routes.query.BranchId ?? 0,
          },
        });
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    };

    function IsConfirmEdit(data) {
      debugger;
      let permissionResult: any = checkPermission(Rights, "Edit");

      if (permissionResult.hasPermission) {
        dataEdit.value = data;
        popup.value.Editmodel = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }

    function IsConfirmDel(data) {
      debugger;
      let permissionResult: any = checkPermission(Rights, "Delete");

      if (permissionResult.hasPermission) {
        dataEdit.value = data;
        popup.value.Editmodel = false;
        popup.value.Deletemodel = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }

    function IsEdit(data) {
      router.push({
        path: "IndentTemplateCreation",
        query: {
          param: "IndentTemplateCreation",
          doctype: data.DocType,
          Id: data.StockTransId,
          StoreId: StoreId,
          status: status,
          Type: Type,
          OperationId: ObjOperationId.value.UpdateId,
          EntityId: ObjOperationId.value.EntityId,
          storebranchmapid: StoreBranchmapId,
          BranchId: routes.query.BranchId ?? 0,
        },
      });
    }

    const rowsCount = ref(0);

    const state = reactive({
      pagedItems: [], // contains a subset of rows for the current page
      currentPage: 1, // current page number
      pageSize: 10, // number of rows per page
      totalRows: 0, // total number of rows in the database
    });

    const windowWidth = ref(window.innerWidth);
    const handleResize = () => {
      windowWidth.value = window.innerWidth;
    };

    onMounted(() => {
      window.addEventListener("resize", handleResize);
      if (windowWidth.value < 545) {
        state.pageSize = 5;
      } else {
        state.pageSize = 10;
      }
    });

    onUnmounted(() => {
      window.removeEventListener("resize", handleResize);
    });

    watch(
      () => windowWidth.value,
      (newVal) => {
        if (newVal < 545) {
          state.pageSize = 5;
        } else {
          state.pageSize = 10;
        }
      }
    );

    function ShowRows(value) {
      debugger;
      if (value != 0 && value != null && value != undefined) {
        state.pageSize = value;
        IsShow();
      }
    }

    watch(
      [() => state.currentPage, () => state.pageSize],
      async ([pageNum, pageSize]) => {
        debugger;
        await IsShow();
      }
    );

    //Get data for TableView
    async function IsShow() {
      debugger;
      try {
        loading.value =
          SearchValue.value.inputValue ||
            SearchValue.value.fromDate ||
            SearchValue.value.toDate
            ? false
            : true;

        let response = await commonService.GetIndentTemplate(
          usersData.OrganizationId,
          usersData.BranchId,
          StoreId
        );

        items.value = response["result"];
        if (items.value.length !== 0) {
          hasData.value = true;
        }

        rowsCount.value =
          response["result"].length > 0
            ? response["result"][0]["rowscount"]
            : 0;

        console.log(items.value);
        loading.value = false;
      } catch (error) {
        console.log(error);
      }
    }

    function RowClick(event: any) {
      rowFocus.value = true;
      dataEdit.value = event.data ? event.data : event;
      router.push({
        path: "/IndentTemplateDetails",
        query: {
          indentTemplateid: event.data
            ? event.data.StockTransId
            : event.StockTransId,
        },
      });
    }

    //Delete Values in Table
    const IsDelete = async (data) => {
      try {
        const response = await commonService.DeleteIndentTemplate(
          data.StockTransId
        );
        let message = response["ErrorInfo"].ErrorCode;
        if (message == null) {
          popup.value.Deletemodel = false;
          popup.value.deletepop = true;
          IsShow();
        }
      } catch (error) {
        console.log(error);
      }
    };

    // Popup-Close
    function closetrigger() {
      popup.value.deletepop = false;
    }
    let FilterLoading = ref(true);
    const filtervisible = ref(false);
    let filterItemsArray: any = ref([]);
    let filterItems = ref({
      Date: "",
      FromStore: "",
      fromstoreId: "",
      Code: "",
      StatusName: "",
      StatusIds: "",
    });

    let emitedfilterItems = ref({
      FromStore: "",
      fromstoreId: "",
      Code: "",
      StatusName: "",
      StatusIds: "",
    });
    let SearchValue = ref({
      inputValue: "",
      fromDate: "",
      toDate: "",
    });

    return {
      headers,
      items,
      IsShow,
      IsDelete,
      generic,
      loading1,
      globalFilterFields,
      filters,
      IsCreate,
      IsEdit,
      menu,
      toggle,
      popup,
      dataEdit,
      IsConfirmEdit,
      IsConfirmDel,
      closetrigger,
      IssueOncick,
      rowsCount,
      state,
      loading,
      itemListed,
      menus,
      CrystalReportPopup,
      ParameterValues,
      filterItemsArray,
      filtervisible,
      SearchValue,
      FilterLoading,
      ShowRows,
      windowWidth,
      visible,
      StatusFilter,
      hasData,
      RowClick,
      PrintType,
      hidepopup
    };
  },
});
</script>

<style lang="scss" scoped>
.table-status {
  padding: 5px 10px;
  background-color: green;
  color: #ffffff;
  border-radius: 5px;
}

.issuebutton {
  padding: 0.2rem 0.5rem !important;
}
</style>
